import { render } from "./IconVitals.vue?vue&type=template&id=03b10c83"
import script from "./IconVitals.vue?vue&type=script&lang=js"
export * from "./IconVitals.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__